var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-field-container"},[_c('p',{staticClass:"text-field-label"},[_vm._v(_vm._s(_vm.fieldLabel)+": ")]),_c('p',{staticClass:"text-field-value"},[_vm._v(_vm._s(_vm.fieldValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }